import React from 'react';
import ReactDOM from 'react-dom';
import { menuPosition } from '../../utils/menuPosition';

// A small "Actions" menu for a table row. The list is drawn in document.body (a portal, position: fixed), so
// neither the card nor the scrolling table can cut it off; reactstrap 7's DropdownMenu has no container or
// positionFixed option. It opens below the button, or above it near the bottom of the window (the last row),
// and closes on a click outside, Escape, a choice, scrolling or resizing.
// items: [{ label, onClick, disabled, danger }, { divider: true }, { header: 'Super admin' }]; props.label: the button's
// text (default "Actions"), props.title: its hover text and accessible name
class RowMenu extends React.Component {
	constructor(props) {
		super(props);
		this.state = { open: false, top: 0, left: 0, placed: false };
		this.button = React.createRef();
		this.menu = React.createRef();
		this.toggle = this.toggle.bind(this);
		this.close = this.close.bind(this);
		this.onDocumentMouseDown = this.onDocumentMouseDown.bind(this);
		this.onKeyDown = this.onKeyDown.bind(this);
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.state.open && !prevState.open) {
			document.addEventListener('mousedown', this.onDocumentMouseDown);
			document.addEventListener('keydown', this.onKeyDown);
			window.addEventListener('scroll', this.close, true);
			window.addEventListener('resize', this.close);
		}
		if (!this.state.open && prevState.open) {
			this.removeListeners();
		}
		// Measured once it is drawn (hidden), then placed next to the button
		if (this.state.open && !this.state.placed && this.menu.current && this.button.current) {
			const button = this.button.current.getBoundingClientRect();
			const menu = { width: this.menu.current.offsetWidth, height: this.menu.current.offsetHeight };
			const position = menuPosition(button, menu, { width: window.innerWidth, height: window.innerHeight });
			this.setState({ top: position.top, left: position.left, placed: true });
		}
	}

	componentWillUnmount() {
		this.removeListeners();
	}

	removeListeners() {
		document.removeEventListener('mousedown', this.onDocumentMouseDown);
		document.removeEventListener('keydown', this.onKeyDown);
		window.removeEventListener('scroll', this.close, true);
		window.removeEventListener('resize', this.close);
	}

	toggle() {
		this.setState((state) => ({ open: !state.open, placed: false }));
	}

	close() {
		if (this.state.open) {
			this.setState({ open: false, placed: false });
		}
	}

	onDocumentMouseDown(e) {
		const inside = (ref) => ref.current && ref.current.contains(e.target);
		if (!inside(this.button) && !inside(this.menu)) {
			this.close();
		}
	}

	onKeyDown(e) {
		if (e.key === 'Escape') {
			this.close();
			if (this.button.current) {
				this.button.current.focus();
			}
		}
	}

	choose(item) {
		this.close();
		if (!item.disabled && item.onClick) {
			item.onClick();
		}
	}

	renderMenu() {
		const { top, left, placed } = this.state;
		const style = { position: 'fixed', top, left, right: 'auto', display: 'block', zIndex: 1040, visibility: placed ? 'visible' : 'hidden' };
		return ReactDOM.createPortal(
			<div ref={this.menu} className="dropdown-menu show billing-row-menu" role="menu" style={style}>
				{this.props.items.map((item, index) => {
					if (item.divider) {
						return <div key={index} className="dropdown-divider" />;
					}
					if (item.header) {
						return <h6 key={index} className="dropdown-header">{item.header}</h6>;
					}
					return (
						<button key={index} type="button" role="menuitem" disabled={item.disabled}
							className={'dropdown-item' + (item.danger ? ' text-danger' : '')} onClick={() => this.choose(item)}>
							{item.label}
						</button>
					);
				})}
			</div>,
			document.body
		);
	}

	render() {
		const { open } = this.state;
		return (
			<React.Fragment>
				<button ref={this.button} type="button" className={'btn btn-outline-secondary btn-sm dropdown-toggle' + (open ? ' active' : '')}
					aria-haspopup="true" aria-expanded={open} title={this.props.title} aria-label={this.props.title} onClick={this.toggle}>
					{this.props.label || 'Actions'}
				</button>
				{open && this.renderMenu()}
			</React.Fragment>
		);
	}
}

export default RowMenu;
